import { c as _c } from "react/compiler-runtime";
import type { ElementType, ReactNode } from 'react';
type CardHeadingProps = {
  title: string;
  description?: ReactNode;
  /* The demo dialog passes Radix's Title and Description so the visible heading names the dialog. */
  Title?: ElementType;
  Description?: ElementType;
};
const CardHeading = t0 => {
  const $ = _c(9);
  const {
    title,
    description,
    Title: t1,
    Description: t2
  } = t0;
  const Title = t1 === undefined ? "h1" : t1;
  const Description = t2 === undefined ? "p" : t2;
  let t3;
  if ($[0] !== Title || $[1] !== title) {
    t3 = <Title className="fp-auth-display text-primary">{title}</Title>;
    $[0] = Title;
    $[1] = title;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== Description || $[4] !== description) {
    t4 = description ? <Description className="fp-auth-lead text-tertiary">{description}</Description> : null;
    $[3] = Description;
    $[4] = description;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t3 || $[7] !== t4) {
    t5 = <div className="flex flex-col gap-1">{t3}{t4}</div>;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default CardHeading;